import React from 'react';

import {
    Box,
  Card,
  CardContent,
  Chip,
  Typography,
} from '@material-ui/core';

import {
    ResponsiveContainer,
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
} from 'recharts';

import { TrendData } from '../types';
import TrendTooltip from './trend-tooltip';
import { DashboardFilters } from '@lib/common/hooks/use-analysis';

interface Props {
  data: TrendData[];  filters: DashboardFilters;
}

const TrendChart = ({ data , filters}: Props) => {
  return (
    <Card
      style={{
        borderRadius: 16,
       // marginTop: 24,
        boxShadow: '0 8px 24px rgba(0,0,0,.08)',
      }}
    >
      <CardContent>

            <Box display="flex" justifyContent="space-between" style={{margin:6}}>

            <Box>

              {  <Typography variant="h6">
                    Daily Trend Activities 
                </Typography>}
{
                <Typography variant="body2" color="textSecondary">
                    Last 7 days
                </Typography>
}
            </Box>

        </Box>
        <Box display="flex"  style={{marginBottom:16}}>

    <Chip
        label={filters.field}
        color="primary"
        size="small"
        style={{ margin: 8 }}
    />

    <Chip
        label={filters.action}
        color="secondary"
        size="small"
        style={{ margin: 8 }}
    />

</Box>

        <div style={{ width: '100%', height: 360 }}>

          <ResponsiveContainer width="100%" height={350}>

                <LineChart
                    data={data}
                >

                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                    />

                    <XAxis
                        dataKey="day"
                    />

                    <YAxis
                tickFormatter={(value)=>
                    Intl.NumberFormat('en',{
                        notation:'compact'
                    }).format(value)
                }
            />

               <Tooltip content={<TrendTooltip />} />

                  {filters.action === 'All' && <Legend />}

                    {(filters.action === 'All' || filters.action === 'Added') && (
                        <Line
                            type="monotone"
                            dataKey="added"
                            name="Added"
                            animationDuration={800}
                            animationEasing="ease-in-out"
                            stroke="#22C55E"
                            strokeWidth={3}
                            dot={{ r: 4 }}
                            activeDot={{ r: 7 }}
                        />
                    )}

                    {(filters.action === 'All' || filters.action === 'Modified') && (
                        <Line
                            type="monotone"
                            dataKey="modified"
                            name="Modified"
                            animationDuration={800}
                            animationEasing="ease-in-out"
                            stroke="#3B82F6"
                            strokeWidth={3}
                            dot={{ r: 4 }}
                            activeDot={{ r: 7 }}
                        />
                    )}

                    {(filters.action === 'All' || filters.action === 'Deleted') && (
                        <Line
                            type="monotone"
                            dataKey="deleted"
                            name="Deleted"
                            animationDuration={800}
                            animationEasing="ease-in-out"
                            stroke="#EF4444"
                            strokeWidth={3}
                            dot={{ r: 4 }}
                            activeDot={{ r: 7 }}
                        />
                    )}
                    
                </LineChart>

            </ResponsiveContainer>

        </div>

      </CardContent>
    </Card>
  );
};

export default TrendChart;